/* eslint-disable no-unused-vars */
import React, { Fragment } from 'react'
import CustomSelect from './CustomSelect'
import { useTranslation } from 'react-i18next'
import { photosListComponentStyles } from '../../styles/classes/GeneralClasses'
import { Divider, Typography, Box } from '@mui/material'
import { attributesOptions, photosItemKeys } from '../../utils/formBuilder'

import TextBox from './TextBox'

const PhotosListItemComponent = ({
  item,
  index,
  disableItems,
  onChangeItemValue,
  selectedMoreThanOne,
  onClearTitle
}) => {
  const { classes } = photosListComponentStyles()
  const { t } = useTranslation()
  return (
    <Fragment>
      <Box>
        <Divider className={classes.divider} />
        <Typography className={classes.photoHeaderText}>
          {t('form_builder.elements.photo_number', { number: index + 1 })}
        </Typography>
      </Box>
      <TextBox
        onClear={() => onClearTitle(index)}
        error={selectedMoreThanOne && item.title === ''}
        small
        name={photosItemKeys.TITLE}
        required={true}
        value={item.title}
        onChange={event => onChangeItemValue(event, index)}
        title={t('form_builder.elements.photo_title')}
        placeholder={t('form_builder.elements.text_input_placeholder')}
        disabled={disableItems}
      />
      <CustomSelect
        IconComponent={() => null} // null to hide arrow icons
        name={photosItemKeys.LOCATION}
        value={
          item.location
            ? t('form_builder.elements.yes')
            : t('form_builder.elements.no')
        }
        onChange={event => onChangeItemValue(event, index)}
        title={t('form_builder.elements.location')}
        options={[
          t('form_builder.elements.yes'),
          t('form_builder.elements.no')
        ]}
        disabled={true}
      />
      <CustomSelect
        IconComponent={() => null} // null to hide arrow icons
        name={photosItemKeys.TIME_STAMP}
        value={
          item.time_stamp
            ? t('form_builder.elements.yes')
            : t('form_builder.elements.no')
        }
        onChange={event => onChangeItemValue(event, index)}
        title={t('form_builder.elements.time_stamp_title')}
        options={[
          t('form_builder.elements.yes'),
          t('form_builder.elements.no')
        ]}
        disabled={true}
      />
      <CustomSelect
        name={photosItemKeys.REQUIRED}
        value={
          item.required
            ? t('form_builder.right_panel.required')
            : t('form_builder.right_panel.optional')
        }
        onChange={event => onChangeItemValue(event, index)}
        title={t('form_builder.elements.required_field_title')}
        options={[
          t('form_builder.right_panel.required'),
          t('form_builder.right_panel.optional')
        ]}
        disabled={disableItems}
      />
      <CustomSelect
        name={photosItemKeys.ATTRIBUTES}
        value={t(`form_builder.elements.${item.attributes}`)}
        onChange={event => onChangeItemValue(event, index)}
        title={t('form_builder.elements.attributes')}
        options={attributesOptions.map(option =>
          t(`form_builder.elements.${option}`)
        )}
        disabled={disableItems}
      />
    </Fragment>
  )
}

export default PhotosListItemComponent
